<template>
  <div class="text-center" ref="createTareaRef" id="text-test">
    <v-dialog
      v-model="modalStatus"
      max-width="800"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-space-between">
              <div class="d-flex flex-row align-center">
                <v-icon color="white" small class="info-icon mr-2">mdi-file-document-multiple-outline</v-icon>
                <p class="mb-0 font-weight-bold text-primary title"
									:class="$vuetify.breakpoint.mobile ? 'body-2':''">
										Nuevo Adicional
										<v-progress-circular v-if="loadingLastAdditionalInfo" indeterminate size="20" width="3" color="#2D4B95"></v-progress-circular>
										<span v-else-if="lastAdditionalInfo && lastAdditionalInfo.number">- Nº {{lastAdditionalInfo.number + 1}}</span>
								</p>
              </div>
							<div class="d-flex flex-row align-center">
								<v-btn class="mx-2" fab dark x-small color="#fb8c00" @click="minimizeForm">
									<v-icon dark>mdi-window-minimize</v-icon>
								</v-btn>
								<v-btn class="mx-2" fab dark small color="#F4516C" @click="closeModalSelf()">
									<v-icon dark>mdi-close</v-icon>
								</v-btn>
							</div>
            </div>
            <v-row align="center" class="mt-2">
              <v-col cols="12">
                <p class="mb-0 body-2"><b class="text-primary">Al enviar este presupuesto estás informando al mandante de mayores o menores costos del proyecto. Tu nombre aparecerá como creador:</b> {{$store.userStore.state.userInfo.name}}</p>
								<p class="mb-0 body-2"><b class="text-primary">En el proyecto:</b> {{selectedProject.name}}</p>
              </v-col>
            </v-row>
            <v-form ref="form" v-model="validform">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Adicional</h2>
                    </v-col>
                    <v-col cols="12" sm="9">
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.type === 1"
												@click="changeAdditionalType(1)"
											>
												<p class="mb-0">Obra Extraordinaria</p>
											</v-btn>
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.type === 2"
												@click="changeAdditionalType(2)"
											>
												<p class="mb-0">Aumento de Obra</p>
											</v-btn>
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.type === 3"
												@click="changeAdditionalType(3)"
											>
												<p class="mb-0">Disminución de Obra</p>
											</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Tipo de Adicional</h2>
                    </v-col>
                    <v-col cols="12" sm="9">
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.cost_type === 1"
												@click="newAdicionalForm.cost_type = 1"
											>
												<p class="mb-0">Suma Alzada [SA]</p>
											</v-btn>
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.cost_type === 2"
												@click="newAdicionalForm.cost_type = 2"
											>
												<p class="mb-0">Serie de Precios Unitarios [SPU]</p>
											</v-btn>
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.cost_type === 3"
												@click="newAdicionalForm.cost_type = 3"
											>
												<p class="mb-0">Valor Proforma [VPF]</p>
											</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Impacto</h2>
                    </v-col>
                    <v-col cols="12" sm="9">
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.impacts_timeline === 1"
												@click="newAdicionalForm.impacts_timeline = 1"
											>
												<p class="mb-0">Afecta el Plazo</p>
											</v-btn>
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.impacts_timeline === 2"
												@click="newAdicionalForm.impacts_timeline = 2"
											>
												<p class="mb-0">No Afecta el Plazo</p>
											</v-btn>
											<v-btn
												dark
												x-small
												color="#5E85EF"
												class="mx-1"
												:outlined="newAdicionalForm.impacts_timeline === 3"
												@click="newAdicionalForm.impacts_timeline = 3"
											>
												<p class="mb-0">Se evaluará</p>
											</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Código</h2>
                    </v-col>
                    <v-col cols="12" sm="9">
											<v-text-field
												v-model="newAdicionalForm.code"
												label="Código"
												placeholder="Ingrese código para el Adicional"
												:hint="lastCode"
												persistent-hint
												dense
												outlined
												required
												:rules="requiredRule"
											>
												<template v-slot:message="{message}">
													<span v-html="message"></span>
												</template>
											</v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
							<v-row align="center">
								<v-col cols="12">
									<v-row align="start">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Asociaciones</h2>
										</v-col>
										<v-col cols="12" sm="9">
											<ItemsAssociationInputSelect ref="itemsAssociationInputSelectRef" :changeItems="changeAssociations"/>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row align="center">
								<v-col cols="12">
									<v-row align="center">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Prioridad</h2>
										</v-col>
										<v-col cols="12" sm="9">
											<div class="d-flex" :class="$vuetify.breakpoint.mobile ? 'flex-column':'flex-row'">
												<v-btn
													class="mx-2 my-1"
													color="#F4516C"
													dark
													small
													:outlined="newAdicionalForm.priority === 3"
													@click="() => newAdicionalForm.priority = 3"
												>
													<p class="mb-0">! Inmediata</p>
												</v-btn>
												<v-btn
													class="mx-2 my-1"
													color="warning"
													dark
													small
													:outlined="newAdicionalForm.priority === 2"
													@click="() => newAdicionalForm.priority = 2"
												>
													<p class="mb-0">! Media</p>
												</v-btn>
												<v-btn
													class="mx-2 my-1"
													color="#3EBFA3"
													dark
													small
													:outlined="newAdicionalForm.priority === 1"
													@click="() => newAdicionalForm.priority = 1"
												>
													<p class="mb-0">! Estándar</p>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row align="center">
								<v-col cols="12">
									<v-row align="center">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Fecha Crítica</h2>
										</v-col>
										<v-col cols="12" sm="9">
											<v-menu
												v-model="datePicker"
												:close-on-content-click="false"
												max-width="290"
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														:value="newAdicionalForm.critical_date"
														label="Fecha Crítica"
														prepend-inner-icon="mdi-calendar"
														readonly
														v-bind="attrs"
														v-on="on"
														outlined
														dense
														class="remove-bottom-details date-limit-input"
														@click:clear="date = null"
													></v-text-field>
												</template>
												<v-date-picker
													locale="es"
													v-model="newAdicionalForm.critical_date"
													@change="datePicker = false"
												></v-date-picker>
											</v-menu>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
              <v-row>
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="12" sm="3">
                      <h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Especialidades</h2>
                    </v-col>
                    <v-col cols="12" sm="9">
                      <div class="d-flex flex-row">
                        <v-select
                          v-model="especialidades"
                          :items="selectedProject.specialties"
                          item-text="name"
                          item-value="id"
                          label="Seleccione Especialidades"
                          single-line
                          hint="Selecciona las especialidades para el adicional"
                          :rules="requiredRule"
                          persistent-hint
                          hide-details
                          multiple
                          outlined
                          dense
                          required
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
							<!-- <v-row>
								<v-col cols="12">
									<v-row>
										<v-col cols="12" sm="3">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold"
														v-bind="attrs"
														v-on="on">Recordatorio</h2>
												</template>
												<span>Se agregará este Adicional a tus recordatorios semanales</span>
											</v-tooltip>
										</v-col>
										<v-col cols="12" sm="9">
											<div>
												<v-btn
													v-for="(day, index) in weekDays"
													:key="index"
													dark
													x-small
													color="#5E85EF"
													:outlined="!isWeekDaySelected(index)"
													class="mx-1"
													@click="addWeekDay(index)"
												>
													<p class="mb-0">{{day}}</p>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row> -->
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Enviar Copia</h2>
                    </v-col>
                    <v-col cols="12" sm="9">
											<v-combobox
												v-model="copy_to"
												:loading="$store.usersStore.state.loadingUserList"
												:items="this.$store.usersStore.state.usersList"
												item-text="name"
												item-value="id"
												single-line
												outlined
												dense
												required
												multiple
												label="Enviar copia por correo"
												hint="Se enviará una copia en PDF del Adicional a los usuarios que indiques aquí. Puedes ingresar un correo que no esté en el listado, escríbelo y presiona enter."
												persistent-hint
												return-object
												taggable
											>
												<template v-slot:item="data">
													<v-list-item-avatar>
														<img v-if="data.item.info && data.item.info.avatar" :src="data.item.info.avatar">
														<v-icon v-else>mdi-account</v-icon>
													</v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title>{{data.item.name}} <span class="light-blue-text">{{data.item.projectjob.userjobtype.name}}</span></v-list-item-title>
														<v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-combobox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div class="d-flex flex-row align-center my-6">
                <v-icon color="white" small class="info-icon mr-2">mdi-file-document-multiple-outline</v-icon>
								<div>
									<p class="mb-0 font-weight-bold text-primary title body-1">Costos Asociados</p>
									<p class="mb-0 caption font-weight-bold" v-if="newAdicionalForm.type == 3">Al ser disminución de obra, estos valores se mostrarán como negativos</p>
								</div>
              </div>
              <v-row>
                <v-col cols="4">
									<h2 class="ml-2 mb-0 body-1 font-weight-bold">Costo Directo</h2>
									<div class="d-flex flex-row">
										<CurrencyInput
											v-model="newAdicionalForm.direct_cost"
											placeholder="Costo Directo"
											outlined
											dense
											rounded
											:mask-prefix="maskPrefix"
											class="custom-input-numbers text-center"
											:rules="[...requiredRule,...decimalsRule]"
											@change="changeDirectCost"
										/>
										<!-- <v-text-field
											v-model="newAdicionalForm.direct_cost"
											placeholder="Costo Directo"
											type="number"
											outlined
											dense
											rounded
											class="custom-input-numbers text-center"
											:rules="[...requiredRule,...decimalsRule]"
											@input="changeDirectCost"
										>
										</v-text-field> -->
									</div>
                </v-col>
                <v-col cols="4">
									<div class="d-flex justify-space-between align-center mx-2">
										<h2 class="mb-0 body-1 font-weight-bold">Gastos Generales</h2>
										<p class="mb-0 caption font-weight-bold">({{ fixedPercentsForAdicionalType.gg }}%)</p>
									</div>
									<div class="d-flex flex-row">
										<CurrencyInput
											v-model="newAdicionalForm.general_expenses"
											placeholder="Gastos Generales"
											outlined
											dense
											rounded
											:mask-prefix="maskPrefix"
											class="custom-input-numbers text-center"
											:rules="[...requiredRuleZero,...decimalsRule]"
										/>
										<!-- <v-text-field
											v-model="newAdicionalForm.general_expenses"
											placeholder="Gastos Generales"
											type="number"
											outlined
											dense
											rounded
											class="custom-input-numbers text-center"
											:rules="[...requiredRuleZero,...decimalsRule]"
										>
										</v-text-field> -->
									</div>
                </v-col>
                <v-col cols="4">
									<div class="d-flex justify-space-between align-center mx-2">
										<h2 class="mb-0 body-1 font-weight-bold">Utilidad</h2>
										<p class="mb-0 caption font-weight-bold">({{ fixedPercentsForAdicionalType.profit }}%)</p>
									</div>
									<div class="d-flex flex-row">
										<CurrencyInput
											v-model="newAdicionalForm.utility"
											placeholder="Utilidad"
											outlined
											dense
											rounded
											:mask-prefix="maskPrefix"
											class="custom-input-numbers text-center"
											:rules="[...requiredRuleZero,...decimalsRule]"
										/>
										<!-- <v-text-field
											v-model="newAdicionalForm.utility"
											placeholder="Utilidad"
											type="number"
											outlined
											dense
											rounded
											class="custom-input-numbers text-center"
											:rules="[...requiredRuleZero,...decimalsRule]"
										>
										</v-text-field> -->
									</div>
                </v-col>
                <v-col cols="8">
									<h2 class="ml-2 mb-0 body-1 font-weight-bold">Moneda</h2>
									<div class="d-flex flex-row">
										<v-select
											v-model="newAdicionalForm.currency_id"
											:items="$store.generalStore.state.systemCurrencies.currencies"
											:loading="$store.generalStore.state.systemCurrencies.loading"
											item-text="name"
											item-value="id"
											label="Seleccione Moneda"
											single-line
											hint="Selecciona la moneda para el adicional"
											:rules="requiredRule"
											persistent-hint
											hide-details
											outlined
											dense
											required
										></v-select>
									</div>
                </v-col>
                <v-col cols="4">
									<h2 class="ml-2 mb-0 body-1 font-weight-bold">Total Solicitado</h2>
									<div class="d-flex flex-row">
										<CurrencyInput
											:value="computedTotalRequest"
											placeholder="Total Solicitado"
											outlined
											dense
											rounded
											:mask-prefix="maskPrefix"
											class="custom-input-numbers text-center"
											readonly
										/>
									</div>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="newAdicionalForm.title"
                    label="Título"
                    placeholder="Ingrese título para el Adicional"
                    outlined
                    required
                    hide-details
                    :rules="requiredRule"
										@keydown="sendToSearch"
                  >
										<template slot="append">
											<v-progress-circular
												v-if="searching"
												:size="20"
												:width="2"
												color="#2D4B95"
												indeterminate
											></v-progress-circular>
											<v-chip
												v-else-if="searchResultsCount > 0"
												dark
												small
												color="#5E85EF"
												@click="showResults = true">
												<v-avatar
													left
													class="primary darken-4"
												>
													{{searchResultsCount}}
												</v-avatar>
												<p class="mb-0">Elementos similares</p>
												<v-icon>mdi-chevron-down</v-icon>
											</v-chip>
										</template>
									</v-text-field>
									<SearchBlockForms v-if="showResults" :searching="searching" :searchResult="searchResult" :closeResults="closeResults"/>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12">
                  <h2 class="ml-2 mb-2 body-1 font-weight-bold">Descripción</h2>
									<InteractionEditor
										v-model="newAdicionalForm.description"
										item_type="additional"
										@paste-image="onPasteImage"
										@mentions-updated="onMentionsUpdated"
									/>
                  <div class="my-2 d-flex flex-row" style="width: 100%">
                    <div class="d-flex flex-row justify-space-between" style="width: 100%">
                      <div class="d-flex flex-row align-center flex-wrap" style="flex: 1;">
                        <div v-for="(file,index) in filesPreview" :key="index" class="ma-1" style="flex: 1 0 45%;">
                          <div v-if="file.src" class="preview-img-container">
                            <v-btn
                              icon
                              color="#5E85EF"
                              x-small
                              class="button-preview-img"
                              @click="removeAttachment(file, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <img :src="file.src" class="preview-img"/>
                          </div>
                          <div v-else class="d-flex flex-row align-center justify-start">
                            <v-btn
                              icon
                              color="#5E85EF"
                              x-small
                              @click="removeAttachment(file, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            {{file.name}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row align="center" class="mt-0">
                <v-col cols="12" sm="6" v-if="!$vuetify.breakpoint.mobile">
                </v-col>
                <v-col cols="12" sm="6">
                  <div class="d-flex flex-row justify-end" style="width: 100%">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													class="mx-2 my-1"
													color="#2D4B95"
													text
													v-bind="attrs"
													v-on="on"
													:disabled="disabledAttachSelector"
													@click="() => attachFiles = !attachFiles"
												>
													<v-icon small class="mr-1">{{attachFiles ? 'mdi-check-circle-outline':'mdi-checkbox-blank-circle-outline'}}</v-icon>
													<p class="mb-0 text-primary text-capitalize caption">Enviar adjuntos</p>
												</v-btn>
											</template>
											<span>Se adjuntarán los archivos en el correo de notificación</span>
										</v-tooltip>
                    <div class="d-flex justify-space-between" style="width: 100%" :class="$vuetify.breakpoint.mobile ? 'flex-column':'flex-row'">
                      <v-btn
                        class="mx-2 my-1"
                        rounded
                        color="white"
                        raised
                        @click="onButtonClick"
                      >
                        <p class="mb-0 text-primary">Adjuntar Archivo</p>
                      </v-btn>
                      <input
                        ref="uploader"
                        class="d-none"
												multiple
												type="file"
												@change="onFilesChanged"
                      >
                      <v-btn
                        v-if="checkPermissions(['create_additionals'])"
                        class="mx-2 my-1"
                        rounded
                        color="#2D4B95"
                        raised
                        :loading="loadingData"
                        @click="() => preCreateAdditional()"
                      >
                        <p class="mb-0 white--text">{{confirmButtonText}}</p>
                      </v-btn>
                      <v-btn
                        v-else
                        class="mx-2 my-1"
                        rounded
                        color="#2D4B95"
                        raised
                        :loading="loadingData"
                        @click="saveDraftAndClose()"
                      >
                        <p class="mb-0 white--text">Guardar Borrador</p>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import _debounce from 'lodash/debounce'
import {create, getLastAdditionalData} from '@/helpers/api/additionals'
import {addInteraction} from '@/helpers/api/tasks'
import {search} from '@/helpers/api/general'
import {deleteFile} from '@/helpers/api/fileManager'
import {create as createDraftAPI, update as updateDraftAPI} from '@/helpers/api/drafts'
import EventBus from '@/helpers/event_bus'
import SearchBlockForms from '@/components/Globals/Headers/SearchBlockForms'
import ItemsAssociationInputSelect from '@/components/Globals/Helpers/ItemsAssociationInputSelect'
import CurrencyInput from '@/components/Globals/Helpers/CurrencyInput'
import InteractionEditor from '@/components/Globals/Helpers/InteractionEditor'

export default {
  name: 'CreateAdditionalModal',
	components: { InteractionEditor, SearchBlockForms, ItemsAssociationInputSelect, CurrencyInput },
  props: {
    modalStatus:{
      type: Boolean,
      default: false
    },
    closeModal: {
      type: Function,
      required: true
    },
    draftToLoad: {
      type: Object,
      default: null
    }
  },
  watch: {
    searchUsers (val) {
      if(val.length > 5){
        // this.searchUsersBD(val)
        this.searchUsersLocal(val)
      }
    },
		draftToLoad(newVal) {
			if(newVal) {
				this.loadDraft(newVal)
			}
		},
		filesPreview() {
			this.checkFilesAttach()
		},
		newAdicionalForm: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		},
		especialidades: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		},
		copy_to: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		},
		associations: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		}
  },
	computed: {
		maskPrefix(){
			if(this.newAdicionalForm.currency_id == 1){
				return 'USD$'
			}
			else if(this.newAdicionalForm.currency_id == 2){
				return '$'
			}
			else if(this.newAdicionalForm.currency_id == 3){
				return 'UF '
			}
			return ''
		},
		selectedProject(){
			return this.$store.projectsStore.state.selectedProject
		},
		computedTotalRequest() {
			const total = 
				parseFloat(this.newAdicionalForm.direct_cost || 0) +
				parseFloat(this.newAdicionalForm.general_expenses || 0) +
				parseFloat(this.newAdicionalForm.utility || 0)

			return total.toFixed(2)
		},
		fixedPercentsForAdicionalType(){
			if(!this.newAdicionalForm || !this.selectedProject.additional_options){
				return {
					gg: 0,
					profit: 0,
				}
			}
			if(this.newAdicionalForm.type == 1){
				return {
					gg: this.selectedProject.additional_options.oe_gg,
					profit: this.selectedProject.additional_options.oe_profit,
				}
			}
			else if(this.newAdicionalForm.type == 2){
				return {
					gg: this.selectedProject.additional_options.ao_gg,
					profit: this.selectedProject.additional_options.ao_profit,
				}
			}
			else if(this.newAdicionalForm.type == 3){
				return {
					gg: this.selectedProject.additional_options.do_gg,
					profit: this.selectedProject.additional_options.do_profit,
				}
			}
			return {
				gg: 0,
				profit: 0,
			}
		},
		lastCode(){
			let code = 'Sin Información'
			if(this.loadingLastAdditionalInfo){
				code = 'Cargando'
			}
			if(this.lastAdditionalInfo){
				code = '<b>' + this.lastAdditionalInfo.code + '</b>'
			}
			return 'Último código generado: ' + code
		}
	},
  data: () => ({
    validform: true,
    newAdicionalForm: {
      title: '',
      type: 1,
			cost_type: 1,
			impacts_timeline: 1,
			code: null,
      description: '',
      priority: 2,
      critical_date: null,
      especialidades: null,
      files: [],
      copy_to: null,
			currency_id: 1,
			direct_cost: 0,
			general_expenses: 0,
			utility: 0,
			total_solicitado: 0,
			reminder: [],
			associations: [],
			reminder_repeatable: true
    },
		attachFiles: false,
		disabledAttachSelector: true,
    loadingSubjects: false,
    projectSubjects: [{name: 'Test', id: 1}, {name: 'Testito', id: 2}],
    especialidades: [],
    copy_to: [],
		associations: [],
    datePicker: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
		requiredRuleZero: [
			v => (v !== null && v !== undefined && v !== '') || 'Campo requerido'
		],
		decimalsRule: [
			v => {
				if (v === null || v === undefined || v === '') return true;
				
				if (typeof v === 'number' && !isNaN(v)) {
					const valueStr = v.toString();
					
					if (!valueStr.includes('.')) return true;
					
					const decimalPart = valueStr.split('.')[1];
					return decimalPart.length <= 2 || 'El monto puede tener máximo 2 decimales';
				}
				
				if (typeof v === 'string') {
					const str = v.toString().trim();
					
					if (/^\d+$/.test(str)) return true;
					if (/^\d+,$/.test(str)) return true;
					if (/^\d+,\d{1,2}$/.test(str)) return true;
					
					const commaIndex = str.lastIndexOf(',');
					if (commaIndex !== -1) {
						const decimalPart = str.substring(commaIndex + 1);
						if (decimalPart.length > 2) {
							return 'El monto puede tener máximo 2 decimales';
						}
					}
					
					return true;
				}
				
				return true;
			}
		],
    newTarea: '',
    subtareas: [],
    files: [],
    filesPreview: [],
    content: '',
    loadingData: false,
    searchUsers: null,
		showResults: false,
		searchResultsCount: 0,
		searching: false,
		searchResult: {},
		cancelTimer: 7,
		inCancelTime: false,
		cancelInterval: null,
		confirmButtonText: 'Confirmar',
		weekDays: ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'],
		loadingLastAdditionalInfo: false,
		lastAdditionalInfo: null,
		draftId: null,
		draftCreated: false,
		draftUpdateInterval: 20,
		draftSaveTimer: null,
		handleFormChangeDebounced: null,
		isResetting: false,
			removedFileUuids: [],
		newInteractionMentions: []
  }),
	beforeUnmount(){
		if(this.draftSaveTimer){
			clearInterval(this.draftSaveTimer)
			this.draftSaveTimer = null
		}
	},
  mounted(){
		this.handleFormChangeDebounced = _debounce(() => this.checkAndCreateDraft(), 1000)
    setTimeout(() => {
      this.pasteListener()
    }, 1000);
    if(this.$store.projectsStore.state.projectSubjects.length == 0){
      this.getProjectSubjects()
    }
    if(this.$store.usersStore.state.usersList.length === 0){
      this.getUsersList()
    }
    if(this.$store.adicionalesStore.state.initialDataAdicional){
      this.newAdicionalForm = {
				...this.newAdicionalForm,
				...this.$store.adicionalesStore.state.initialDataAdicional
			}
			if (this.$store.adicionalesStore.state.initialDataAdicional.associations && this.$store.adicionalesStore.state.initialDataAdicional.associations.length > 0) {
				this.associations = this.$store.adicionalesStore.state.initialDataAdicional.associations
				this.$refs.itemsAssociationInputSelectRef.setSelectedItems(this.associations)
			}
      this.$store.adicionalesStore.commit('setInitialDataAdicional', null)
    }
		this.newAdicionalForm.currency_id = this.selectedProject.details.currency
		this.getLastAdditionalInfo()
		// Cargar draft si viene en la prop al montar el componente
		if(this.draftToLoad){
			this.loadDraft(this.draftToLoad)
		}
		this.fileListeners()
  },
  methods: {
		async onPasteImage(file){
			await this.createDraft()
			this.onFileChanged(null, file)
		},
		onMentionsUpdated(userIds){
			this.newInteractionMentions = userIds
		},
		handleFormChange(){
			if(!this.isResetting && this.handleFormChangeDebounced){
				this.handleFormChangeDebounced()
			}
		},
		checkAndCreateDraft(){
			if(!this.draftCreated && !this.draftId){
				this.createDraft()
			}
		},
		async createDraft(){
			if(this.draftCreated) return
			this.draftCreated = true
			
			const draftData = {
				project_id: this.selectedProject.id,
				type: 3,
				data: JSON.stringify({
					form: this.newAdicionalForm,
					especialidades: this.especialidades,
					copy_to: this.copy_to,
					associations: this.associations
				})
			}
			
			try {
				const response = await createDraftAPI(draftData)
				if(response.code === 200){
					this.draftId = response.draft.id
					this.startDraftUpdateTimer()
				}
        else if(response.offline) {
					this.$store.globalStore.dispatch('addMessage', {
						message: 'No hay conexión. El borrador se mantendrá localmente y podrás retomarlo cuando vuelvas a tener conexión desde la sección de borradores.',
						title: 'Borrador guardado localmente',
						created: new Date(),
						type: 'warning',
						icon: 'mdi-wifi-off',
						color: '#F59E0B'
					})
					this.draftId = response.draft.id
					this.startDraftUpdateTimer()
					return this.draftId
        }
			} catch (error) {
				console.error('Error al crear borrador:', error)
				this.draftCreated = false
			}
		},
		startDraftUpdateTimer(){
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}
			
			this.draftSaveTimer = setInterval(() => {
				this.updateDraft()
			}, this.draftUpdateInterval * 1000)
		},
		async updateDraft(){
			if(!this.draftId) return
			
			const draftData = {
				id: this.draftId,
				type: 3,
				data: JSON.stringify({
					form: this.newAdicionalForm,
					especialidades: this.especialidades,
					copy_to: this.copy_to,
					associations: this.associations
				})
			}
			
			try {
				await updateDraftAPI(draftData)
			} catch (error) {
				console.error('Error al actualizar borrador:', error)
			}
		},
		changeAdditionalType(type){
			this.newAdicionalForm.type = type
			this.changeDirectCost(this.newAdicionalForm.direct_cost)
		},
		changeDirectCost(value) {
			if (this.fixedPercentsForAdicionalType.gg) {
				const gg = value * this.fixedPercentsForAdicionalType.gg / 100
				this.newAdicionalForm.general_expenses = parseFloat(gg.toFixed(2)) // número con 2 decimales
			}
			if (this.fixedPercentsForAdicionalType.profit) {
				const profit = value * this.fixedPercentsForAdicionalType.profit / 100
				this.newAdicionalForm.utility = parseFloat(profit.toFixed(2)) // número con 2 decimales
			}
		},
		changeAssociations(associations){
			this.associations = associations.map((association) => {
				return { type: association.type, id: association.id }
			})
		},
		async getLastAdditionalInfo(){
			this.loadingLastAdditionalInfo = true
			try{
				const lastInfo = await getLastAdditionalData({project_id: this.selectedProject.id})
				if(lastInfo.code == 200){
					this.lastAdditionalInfo = lastInfo.last_additional
					this.setSugggestedCode()
				}
			}
			catch(e){
        const datas = {
					message: 'Hubo un error al obtener la información del último adicional creado. De todas formas podrás crearlo sin problemas.',
					title: 'Error',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
        }
        this.$store.globalStore.dispatch('addMessage', datas)
			}
			this.loadingLastAdditionalInfo = false
		},
		setSugggestedCode(){
			if(this.lastAdditionalInfo && this.lastAdditionalInfo.code){
				const numbers = this.lastAdditionalInfo.code.match(/\d+$/)
				if( numbers[0] && /^-?[\d.]+(?:e-?\d+)?$/.test(numbers[0]) ){
					const lastCharInt = parseInt(numbers)
					this.newAdicionalForm.code = numbers.index > 0 ? this.lastAdditionalInfo.code.slice(0, -1) + ( lastCharInt + 1 ):lastCharInt + 1
				}
			}
		},
		closeResults(){
			this.showResults = false
			this.searching = false
		},
    sendToSearch: _debounce(function(){ this.searchForString(this.newAdicionalForm.title) }, 800),
		async searchForString(searchString){
			this.searching = true
			const data = {
				search: searchString,
				project_id: this.selectedProject.id,
				exclude_description: true
			}
			const searchResult = await search(data)
			if(searchResult.code == 200){
				this.searchResult = searchResult
				this.searchResultsCount = searchResult.tasks.length + searchResult.rdis.length
			}
			this.searching = false
		},
		addWeekDay(index){
			const found = this.newAdicionalForm.reminder.findIndex((itemReminder) => itemReminder === index)
			if(found !== -1){
				this.newAdicionalForm.reminder.splice(found, 1)
			}
			else{
				this.newAdicionalForm.reminder.push(index)
			}
			if(this.newAdicionalForm.reminder.length === 0){
				this.newAdicionalForm.reminder_repeatable = false
			}
		},
		isWeekDaySelected(index){
			return this.newAdicionalForm.reminder.includes(index)
		},
		minimizeForm(){
			this.updateDraft()
			let title = 'Borrador Adicional: '
			if(this.newAdicionalForm.title && this.newAdicionalForm.title != ''){
				title += this.newAdicionalForm.title
			}
			else{
				title += 'Sin Título'
			}
      const data = {
        task_id: uuidv4(),
        title,
        type: 'Adicional',
        type_id: 6,
        number: null,
				newAdicionalForm: this.newAdicionalForm,
				draft_id: this.draftId,
      }
      this.$store.globalStore.commit('addTaskToTasksHandler', data)
      this.closeModalSelf()
    },
		closeModalSelf(){
			if(this.handleFormChangeDebounced){
				this.handleFormChangeDebounced.cancel()
			}
			this.updateDraft()
			this.isResetting = true
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}

			this.closeModal()

			this.newAdicionalForm = {
				title: '',
				type: 1,
				cost_type: 1,
				impacts_timeline: 1,
				description: '',
				especialidades: null,
				files: [],
				copy_to: null,
				currency_id: 1,
				direct_cost: 0,
				general_expenses: 0,
				utility: 0,
				total_solicitado: 0,
				reminder: [],
				associations: [],
				reminder_repeatable: true
			}
			this.especialidades = []
			this.copy_to = []
			this.associations = []
			this.filesPreview = []
			this.searchUsers = null
			this.showResults = false
			this.searchResultsCount = 0
			this.searching = false
			this.searchResult = {}
			this.datePicker = false
			this.loadingData = false
			this.draftId = null
			this.draftCreated = false
			this.removedFileUuids = []
			this.newInteractionMentions = []

			this.$nextTick(() => {
				setTimeout(() => {
					this.isResetting = false
				}, 100)
			})
		},
		async loadDraft(draft){
			if(!draft) return

			// Reset estado previo
			this.isResetting = true
			this.removedFileUuids = []
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}

			// Parsear data si es string
			let draftData = draft.data
			if(typeof draftData === 'string'){
				try {
					draftData = JSON.parse(draftData)
				} catch (error) {
					console.error('Error al parsear draft data:', error)
					this.isResetting = false
					return
				}
			}

			// Populate formulario
			if(draftData.form){
				this.newAdicionalForm = {...this.newAdicionalForm, ...draftData.form}
			}
			this.newInteractionMentions = []

			// Populate especialidades
			if(draftData.especialidades && Array.isArray(draftData.especialidades)){
				this.especialidades = [...draftData.especialidades]
			}

			// Populate copy_to
			if(draftData.copy_to && Array.isArray(draftData.copy_to)){
				this.copy_to = [...draftData.copy_to]
			}

			// Populate asociaciones
			if(draftData.associations && Array.isArray(draftData.associations)){
				this.associations = [...draftData.associations]
			}

			// Cargar archivos del draft
			try{
				const filePreviews = []
				
				if(draft.files && Array.isArray(draft.files)){
					for(const file of draft.files){
						if(file.mime_type && file.mime_type.includes('image')){
							if(file.pathmedia?.path){
								filePreviews.push({src: file.pathmedia.path, id: file.id, name: file.name})
							}
							else{
								filePreviews.push({noImage: true, id: file.id, name: file.name})
							}
						}
						else{
							filePreviews.push({noImage: true, id: file.id, name: file.name})
						}
					}
				}
				
				this.filesPreview = filePreviews
			}
			catch(error){
				console.error('Error al cargar archivos del draft:', error)
			}

			// Establecer draftId
			this.draftId = draft.id
			this.draftCreated = true

			// Iniciar timer de actualizaciones
			this.startDraftUpdateTimer()

			// Limpiar estado
			this.$nextTick(() => {
				this.isResetting = false
			})

			// Notificar al usuario
			const data = {
				message: 'Borrador cargado correctamente. Los cambios se guardarán automáticamente.',
				title: 'Borrador Cargado',
				created: new Date(),
				type: 'success',
				icon: 'mdi-check-circle',
				color: '#3EBFA3'
			}
			this.$store.globalStore.dispatch('addMessage', data)
		},
    pasteListener(){
      const textEditor = document.querySelector('#create-tarea-text-editor .ProseMirror')
      if(textEditor){
        textEditor.addEventListener('paste', async (event) => {
          const dT = event.clipboardData || window.clipboardData
          const file = dT.files[0]
          if(file){
            const uuid = uuidv4()
            if(file.type.includes('image')){
              const base64File = await this.toBase64(file)
              this.filesPreview.push({src: base64File, name: file.name, uuid})
            }
            else{
              this.filesPreview.push({noImage: true, name: file.name, uuid})
            }
          }
        })
      }
    },
    async getProjectSubjects(){
      this.$store.projectsStore.dispatch('getProjectSubjects', this.selectedProject.id)
    },
    async getUsersList(){
      const data = {
        project_id: this.selectedProject.id,
        start: 0,
        limit: 20
      }
      this.$store.usersStore.dispatch('getUsersList', data)
    },
    searchUsersLocal(searchString){
      this.loadingUsers = true
      const search = this.$store.usersStore.state.usersList
      this.usersToSelect = search.filter((user) =>{
        return user.name.includes(searchString) || user.email.includes(searchString) 
      })
      this.loadingUsers = false
    },
    usersFilter(item, queryText) {
      const name = item.name.toLowerCase()
      const email = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || email.indexOf(searchText) > -1
    },
    async getAdditionalList(){
      let project_id = null
      if(this.selectedProject){
        project_id = this.selectedProject.id
      }
      else{
        const id = localStorage.getItem('selectedProjectID')
        project_id = parseInt(id)
      }
      if(project_id){
        this.$store.adicionalesStore.dispatch('getAdditionals', {project_id})
      }
    },
    async getAdditionalLikelyList(){
      let project_id = null
      if(this.selectedProject){
        project_id = this.selectedProject.id
      }
      else{
        const id = localStorage.getItem('selectedProjectID')
        project_id = parseInt(id)
      }
      if(project_id){
				this.$store.adicionalesStore.dispatch('getAdditionalsLikely', {project_id})
			}
    },
    getColorStatus(){
      if(this.$store.consultasStore.state.currentTarea.status === 1){
        return '#3EBFA3'
      }
      return '#F4516C'
    },
    onButtonClick() {
      this.$refs.uploader.click()
    },
		async onFilesChanged(e) {
			await this.createDraft();
			const files = e?.target?.files || []
			for (let i = 0; i < files.length; i++) {
				await this.onFileChanged(null, files[i])
			}
		},
		async onFileChanged(e, file = null) {
			if(!this.draftId && !this.draftCreated){
				await this.createDraft()
			}
			const newFile = e?.target?.files?.[0] || file
			if(!newFile) return
      const uuid = uuidv4()
      if(newFile.type.includes('image')){
        const base64File = await this.toBase64(newFile)
        this.filesPreview.push({src: base64File, name: newFile.name, uuid})
      }
      else{
        this.filesPreview.push({noImage: true, name: newFile.name, uuid})
      }
      
      // Enviar a subida con draft_id y type: 13
      const fileToUpload = {
        type: 13,
        payload: {draft_id: this.draftId, project_id: this.selectedProject.id, uuid},
        description: this.newAdicionalForm.title,
        total: newFile.size,
        uuid,
        file: newFile,
        attach_files: this.attachFiles,
        copy_to: this.newAdicionalForm.copy_to
      }
      this.$store.globalStore.commit('setFilesToUploadCenter', fileToUpload)
    },
    removeAttachment(file, index){
      this.filesPreview.splice(index, 1)
      if(file.id){
        deleteFile({file_id: file.id})
			}
			else if(file.uuid){
				this.removedFileUuids.push(file.uuid)
      }
    },
		checkFilesAttach(){
			if(this.filesPreview.length > 0){
				this.disabledAttachSelector = false
			}
			else{
				this.disabledAttachSelector = true
				this.attachFiles = false
			}
		},
		fileListeners(){
			EventBus.$on('completedFileUpload', async (payload) => {
				if(payload && payload.draft_id === this.draftId){
					if(this.removedFileUuids.includes(payload.uuid)){
						deleteFile({file_id: payload.file.id})
						this.removedFileUuids = this.removedFileUuids.filter(uuid => uuid !== payload.uuid)
						return
					}
					const findIndex = this.filesPreview.findIndex((file) => file.uuid === payload.uuid)
					if(findIndex !== -1){
						this.$set(this.filesPreview[findIndex], 'id', payload.file.id)
					}
				}
			})
		},
    toBase64(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result)
        };
        reader.onerror = function () {
          resolve(null)
        };
      })
    },
    preCreateAdditional(){
			if(this.inCancelTime){
				clearInterval(this.cancelInterval)
				this.confirmButtonText = 'Confirmar'
				this.inCancelTime = false
				return null
			}
      if(this.newAdicionalForm.description === '' || !this.newAdicionalForm.description){
        const datas = {
         message: 'Por favor escribe una descripción. Este campo no puede estar vacio.',
         title: 'Error',
          created: new Date(),
          type: 'success',
          icon: 'mdi-alert-circle',
          color: '#fb8c00'
        }
        this.$store.globalStore.dispatch('addMessage', datas)
        return false
      }
      if(this.$refs.form.validate()){
				this.inCancelTime = true
				this.cancelTimer = 7
				this.confirmButtonText = 'Cancelar (' + this.cancelTimer + ')'
				this.cancelInterval = setInterval(() => {
					this.cancelTimer--
					this.confirmButtonText = 'Cancelar (' + this.cancelTimer + ')'
					if(this.cancelTimer == 0){
						this.inCancelTime = false
						clearInterval(this.cancelInterval)
						this.createAdditional()
					}
				}, 1000);
      }
    },
    async saveDraftAndClose() {
      try {
        this.loadingData = true
        await this.updateDraft()
        this.$store.globalStore.dispatch('addMessage', {
          message: 'Borrador guardado correctamente.',
          title: 'Borrador Guardado',
          type: 'success',
          icon: 'mdi-check-circle',
          color: '#3EBFA3',
          created: new Date()
        })
        this.closeModalSelf()
      } catch(error) {
        console.error('Error al guardar borrador:', error)
        this.$store.globalStore.dispatch('addMessage', {
          message: 'Error al guardar el borrador. Por favor, intenta de nuevo.',
          title: 'Error',
          type: 'error',
          icon: 'mdi-alert-circle',
          color: '#fb8c00',
          created: new Date()
        })
      } finally {
        this.loadingData = false
      }
    },
    async createAdditional(){
			this.loadingData = true
			this.confirmButtonText = 'Confirmar'
			const newAdicionalForm = {...this.newAdicionalForm}
			if(this.especialidades.length > 0){
				newAdicionalForm.especialidades = JSON.stringify(this.especialidades)
			}

			const associations = [...this.associations]
			if (this.newAdicionalForm.item_association_type && this.newAdicionalForm.item_association_id) {
				associations.push({
					type: this.newAdicionalForm.item_association_type,
					id: this.newAdicionalForm.item_association_id
				})
			}
			newAdicionalForm.associations = JSON.stringify(associations)

			if(this.copy_to.length > 0){
				const emails_copy = this.copy_to.map((email) => {
					let emailData = null
					if(email.email){
						emailData = {email: email.email, name: email.name}
					}
					else{
						emailData = {email, name: ''}
					}
					return emailData
				})
				newAdicionalForm.copy_to = JSON.stringify(emails_copy)
			}

			const hasReminders = newAdicionalForm.reminder?.length > 0
			newAdicionalForm.reminder = JSON.stringify(newAdicionalForm.reminder)
			newAdicionalForm.project_id = this.selectedProject.id
			newAdicionalForm.draft_id = this.draftId
			
			const formData = new FormData()
			Object.keys(newAdicionalForm).forEach((key) => {
				const value = newAdicionalForm[key]
				if (value !== null && value !== undefined && value !== '') {
					formData.append(key, value)
				}
			})
			this.newInteractionMentions.forEach((mention) => formData.append('mentions[]', mention))
			const biggerFiles = []
			try {
				const additional = await create(formData)
				if(additional.code === 200){
					// Detener timer del draft después de confirmación exitosa
					if(this.draftSaveTimer){
						clearInterval(this.draftSaveTimer)
						this.draftSaveTimer = null
					}
					await this.getAdditionalList()
					await this.getAdditionalLikelyList()
					this.closeModalSelf()

					//Verificar si se debe cargar una tarea previamente cargada (asociación)
					if(associations.length > 0){
						associations.forEach(association => {
							EventBus.$emit('reload_element', association)
						});
					}
					// Se cambia la llamada directo por el evento, así sólo será escuchado si el componente está montado (evita llamar a la api innecesariamente)
					// this.$store.projectsStore.dispatch('getDashboardInfo');
					EventBus.$emit('onProjectElementsChange')

					this.setMessage(additional.additional, biggerFiles.length > 0)
					hasReminders && this.$store.notificationsStore.dispatch('getReminders')
				}
			} catch (error) {
				let data = {
					message: 'Ha ocurrido un error, por favor intenta nuevamente.',
					title: 'Error',
					created: new Date(),
					type: 'error',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				}
				if(error.data.is_code_used){
					this.getLastAdditionalInfo()
				}
				if(error.data.message){
					data = {
						message: error.data.message,
						title: 'Error',
						created: new Date(),
						type: 'error',
						icon: 'mdi-alert-circle',
						color: '#fb8c00'
					}
				}
				this.$store.globalStore.dispatch('addMessage', data)
			}
			this.loadingData = false
    },
		async setCreateAdditionalMessageToTask(additional, newAdicionalForm){
			if(newAdicionalForm.item_association_type == 'task'){
				const message = 'El Posible Adicional/Tarea ha pasado a Adicional Nº ' + additional.number
				const data = {
					task_id: newAdicionalForm.item_association_id,
					message
				}
				addInteraction(data)
			}
		},
		checkReloadTask(task){
			if(this.$store.consultasStore.state.currentTarea && this.$store.consultasStore.state.currentTarea.id == task.id){
        this.$store.consultasStore.commit('setCurrentTarea', task)
			}
		},
    setMessage(additional, filesToUC = false){
      let message = 'Haz click aquí para visualizarla.'
			if(filesToUC){
				message += ' Hay algunos archivos que se están cargando.'
			}
      const data = {
        message,
        title: 'Se ha creado el Adicional ' + additional.code,
        created: new Date(),
        type: 'success',
        icon: 'mdi-check-circle',
        color: '#3EBFA3',
        action: 'additional',
        task_id: additional.id
      }
      this.$store.globalStore.dispatch('addMessage', data)
    },
  }
};
</script>

<style scoped>
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #2D4B95;
  }
  .info-icon{
    background-color: #2D4B95;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #5E85EF;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  .date-limit-input{
    max-width: 250px;
  }
  .preview-img-container{
    position: relative;
  }
  .preview-img{
    width: 50px;
    height: 50px;
    border-radius: 10px;
    object-fit: contain;
  }
  .button-preview-img{
    position: absolute;
    top: -1px;
    left: -1px;
    background-color: white;
  }
  /deep/ .remove-bottom-details .v-text-field__details{display: none;}
  /deep/ .remove-bottom-details .v-input__slot{margin-bottom: 0;}
/*  /deep/ .text-editor.tiptap-vuetify-editor .ProseMirror{
    margin: 0!important;
  }*/
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
	/deep/ .custom-input-numbers input::-webkit-outer-spin-button,
	/deep/ .custom-input-numbers input::-webkit-inner-spin-button {
			/* display: none; <- Crashes Chrome on hover */
			-webkit-appearance: none;
			margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
	}

	/deep/ .custom-input-numbers input[type=number] {
			-moz-appearance:textfield; /* Firefox */
	}
</style>